var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-view',{staticClass:"v-application",attrs:{"id":"app","name":"drive"}})
}
var staticRenderFns = []

export { render, staticRenderFns }